/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:54
 */
import AssetColumn from "./AssetColumn";

class FileColumn extends AssetColumn {

  constructor(params) {
    params.type = 'file';
    super(params);
    this.init();
    this.bindListeners();
  };

  bindListeners() {
    super.bindListeners();
  };

  lBrowseButtonClick(ev) {
    ev.preventDefault();
    this.$root.find('input[type="file"]').trigger('click');
    return false;
  };

  updateDownloadButtonState(file) {
    this.setButtonState('download', this.storedFilename() && !file);
  }

  storedFilename() {
    return this.filenameEl().dataset.storedFilename;
  }

  filenameEl() {
    return this.rootEl.querySelector('.js-filename');
  }
}

export default FileColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/FileColumn.js